module.exports = __webpack_public_path__ + "img/p4_new01.e9c8c9a8.png";